import React, { useState, useEffect } from 'react';
import { Button } from '@blueprintjs/core';
import api from '../../common/lib/api';

export function KeypadActions({ token, device }) {
  const [action, setAction] = useState('none');
  const [state, setState] = useState({
    data: { partitions: [] },
  });

  useEffect(() => {
    let timeout;
    if (action !== 'none') {
      timeout = setTimeout(() => {
        setAction('none');
        timeout = undefined;
      }, 30e3);
      return () => {
        if (timeout) {
          clearTimeout(timeout);
        }
      };
    }
  }, [action]);

  useEffect(() => {
    console.log(device.deviceUuid, token);
    let connection = new WebSocket(
      window.location.origin.replace('http', 'ws') +
        `/api/v0/devices/${device.deviceUuid}/keypad/partition-zone-map/stream`,
      [token]
    );
    // Log errors
    connection.onerror = function (error) {
      console.log('keypad connection error ' + error);
    };
    // Log messages from the server
    connection.onmessage = function (e) {
      setState(JSON.parse(e.data));
    };
    connection.onclose = function (e) {
      console.log('keypad connection closed');
    };
    return () => {
      connection.close();
    };
  }, [device.deviceUuid, token]);

  return (
    <table className='bp3-html-table'>
      {state.data.partitions.map((partition) => {
        if (partition.state === 'Enter Access Code' && action !== 'none') {
          const code = prompt('Enter access code');
          if (code) {
            setAction('none');
            api.post(`/devices/${device.deviceUuid}/keypad/action`, {
              action: 'send-code',
              partitionNumber: partition.partition,
              userCode: code,
            });
          }
        }
        return (
          <tbody key={'parition' + partition.partition}>
            <tr>
              <th colSpan='2'>{'Partition ' + partition.partition}</th>
              <td>{partition.state}</td>
              <td>
                <Button
                  onClick={async () => {
                    setAction('arming');
                    try {
                      await api.post(`/devices/${device.deviceUuid}/keypad/action`, {
                        action: 'arm',
                        partitionNumber: partition.partition,
                      });
                    } catch (e) {
                      alert(e.message);
                    }
                  }}
                >
                  Arm
                </Button>
                <Button
                  type='button'
                  onClick={async () => {
                    try {
                      setAction('arming');
                      api.post(`/devices/${device.deviceUuid}/keypad/action`, {
                        action: 'arm-stay',
                        partitionNumber: partition.partition,
                      });
                    } catch (e) {
                      alert(e.message);
                    }
                  }}
                >
                  Arm-Stay
                </Button>
                <Button
                  onClick={async () => {
                    try {
                      const code = prompt('Enter access code');
                      if (code) {
                        await api.post(`/devices/${device.deviceUuid}/keypad/action`, {
                          action: 'disarm',
                          partitionNumber: partition.partition,
                          userCode: code,
                        });
                      }
                    } catch (e) {
                      alert(e.message);
                    }
                  }}
                >
                  Disarm
                </Button>
              </td>
            </tr>
            {partition.zones.map((zone) => {
              return (
                <tr key={'zone' + zone.zone}>
                  <td></td>
                  <th>{'Zone ' + zone.zone}</th>
                  <td>{zone.status}</td>
                  <td>
                    <Button
                      onClick={async () => {
                        await api.post(`/devices/${device.deviceUuid}/keypad/zone-bypass`, {
                          zoneNumber: zone.zone,
                          partitionNumber: partition.partition,
                        });
                      }}
                    >
                      Bypass
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        );
      })}
    </table>
  );
}
